import styled from "styled-components";

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 100px;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    margin: 40px;
  }
`;
export const ContentRow = styled.div`
  padding: 0;
`;
export const ContentTitle = styled.div`
  font-family: GT Walsheim Pro;
  font-size: 30px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: 0.5px;
  margin-top: 20px;
  color: #09005b;
  display: flex;
  align-items: center;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    font-size: 26px;
    line-height: 32px;
  }
`;
export const ContentDescription = styled.p`
  font-family: GT Walsheim Pro;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #5e5e5e;
  border-bottom: 1px solid #e8eaed;
  padding-bottom: 10px;
  margin-bottom: 20px;
  display: flex;
  gap: 20px;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    font-size: 14px;
    line-height: 24px;
  }
  span {
    display: flex;
    align-items: center;
  }

  span > svg {
    background-color: #00c7031a;
    padding: 3px;
    border-radius: 50%;
    color: #00c703;
  }
`;
export const ContentAmount = styled.p`
  font-family: GT Walsheim Pro;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #0e0e0e;
  border-bottom: 1px solid #e8eaed;
  padding-bottom: 10px;
  margin-bottom: 10px;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    margin-bottom: 0;
    padding-bottom: 70px;
    border-bottom: none;
  }
`;
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

export const ContentWrapperTitle = styled.div`
  display: flex;
  flex-direction: row;

  margin-right: 20%;
  margin-left: 18%;
  align-items: flex-end;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    margin: 0;
  }
`;
